import { render, staticRenderFns } from "./ListMultiForm.vue?vue&type=template&id=0caff95d&scoped=true"
import script from "./ListMultiForm.vue?vue&type=script&lang=js"
export * from "./ListMultiForm.vue?vue&type=script&lang=js"
import style0 from "./ListMultiForm.vue?vue&type=style&index=0&id=0caff95d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caff95d",
  null
  
)

export default component.exports